import { useQuery } from 'react-query'

import { getTransfersAuthCodeUseCase } from '@webapp/platform/banking/business-logic/use-cases/GetTransfersAuthCode'
import { financialAccountQueryConfig } from '@webapp/platform/banking/query-configs/financialAccount'

type UseQueryTransfersAuthCodeReturn = {
  data: {
    authCode: string | undefined
    codeVerifier: string | undefined
  }
  isFetching: boolean
}

export const useQueryTransfersAuthCode = ({
  onError,
  onSuccess,
  enabled = true,
}: {
  onError?: (error: Error) => void
  onSuccess?: (data: { authCode: string; codeVerifier: string }) => void
  enabled?: boolean
}): UseQueryTransfersAuthCodeReturn => {
  const { data, isFetching } = useQuery({
    queryKey: financialAccountQueryConfig.getAirwallexAuthCode().queryKey,
    queryFn: () => getTransfersAuthCodeUseCase(),
    onError,
    onSuccess,
    enabled,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  })

  return {
    data: { authCode: data?.authCode, codeVerifier: data?.codeVerifier },
    isFetching,
  }
}
